/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { CertificateIcon, StarIcon, TargetIcon } from '@coursera/cds-icons';

import type { ValuePropItem } from 'bundles/cds-labs/components/Modules/ValuePropsModule';
import ValuePropsModule from 'bundles/cds-labs/components/Modules/ValuePropsModule';
import { unifiedModuleColors } from 'bundles/cds-labs/components/Modules/utils/colors';
import { numberOfProductsWithPlusSign } from 'bundles/coursera-plus/utils/courseraPlusUtils';

import _t from 'i18n!nls/coursera-plus-landing-page';

const styles = {
  icon: css`
    width: 32px;
    height: 32px;
  `,
};

const CourseraPlusValueProps = () => {
  const headline = _t('Invest in your career');
  const valueProps: ValuePropItem[] = [
    {
      id: '1',
      headline: _t('Explore new skills'),
      description: _t('Access #{numberOfCourses} courses in AI, business, technology, and more.', {
        numberOfCourses: numberOfProductsWithPlusSign,
      }),
      icon: <TargetIcon size="large" css={styles.icon} />,
    },
    {
      id: '2',
      headline: _t('Earn valuable credentials'),
      description: _t(
        'Get certificates for every course you finish and boost your chances of getting hired after your trial ends at no additional cost.'
      ),
      icon: <CertificateIcon size="large" css={styles.icon} />,
    },
    {
      id: '3',
      headline: _t('Learn from the best'),
      description: _t(
        'Take your skills to the next level with expert-led courses and Coursera Coach, your AI-powered guide.'
      ),
      icon: <StarIcon size="large" css={styles.icon} />,
    },
  ];
  return (
    <ValuePropsModule
      backgroundColor={unifiedModuleColors.lightBlue}
      headline={headline}
      valueProps={valueProps}
      layout="text-top/image-bottom"
      cardBackgroundColor="none"
    />
  );
};

export default CourseraPlusValueProps;
